import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    appSettings: {
      clientsSellersIds: [],
      competitorsSellersIds: [],
      historyIds: [],
      matchingBrands: [],
      minLastPriceUpdate: null,
    },
    brands: [],
    brandsSearch: "",
    classifications: [],
    classificationsSearch: "",
    individualQmpsCardVisible: false,
    loadingBrands: false,
    loadingMatchRanking: false,
    loadingClassifications: false,
    loadingIndexCreation: false,
    loadingPivotItems: false,
    loadingProductCreation: false,
    loadingQmps: false,
    loadingRemoveQmiFromQmp: false,
    loadingRemoveQmp: false,
    loadingSimilarItems: false,
    loadingSimilarItemsQmps: false,
    pivotItems: [],
    pivotItemsFetch: 1,
    pivotItemsOffset: 0,
    pivotItemsTotal: null,
    qmps: [],
    qmpsFetch: 10,
    qmpsOffset: 0,
    qmpsTotal: null,
    selectedItems: [],
    showOnlyPendingClassifications: true,
    sidebarVisible: true,
    similarItems: [],
    similarItemsFetch: 50,
    similarItemsFilters: {
      likePatternBrand: null,
      likePatternName: null,
      maxPrice: null,
      minPrice: null,
    },
    similarItemsFilterSellerIdOrName: null,
    similarItemsOffset: 0,
    similarItemsHideThoseWithQmp: false,
    similarItemsOrderBy: "sql",
    similarItemsQmps: {},
    similarItemsTotal: null,
    matchRanking: [],
    showMatchRankingSidebar: false,
    sellerHomologations: []
  },
};
